export default __webpack_public_path__ + "static/KeywordResearch_01_04@2x-efb6a93c723bc09936325b37b92ab026.webp";